import { render, staticRenderFns } from "./LogisticsDateVersionPicker.vue?vue&type=template&id=1ddba758&scoped=true"
import script from "./LogisticsDateVersionPicker.vue?vue&type=script&lang=js"
export * from "./LogisticsDateVersionPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddba758",
  null
  
)

export default component.exports